import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { Col, Row, Table, Grid, Divider, Pagination } from "antd";
import { PageName, SearchContainer, SearchIcon, SearchInput, SearchButton, StyledCard } from './style';
import { MyText } from "../../components";
import { SearchOutlined } from "@ant-design/icons";
import {useTranslation} from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { fetchKindergartensListAction } from "../../utils";
const isMobile = window.innerWidth < 768;

export const KindergartenListPage = () => {
  const {t} = useTranslation("common")
  const { useBreakpoint } = Grid;
  const dispatch = useDispatch();
  const kindergartensList = useSelector((state: any) => state.materials.kindergartensList);
  const kindergartens = kindergartensList.data?.kindergartens || [];
  const totalCount = kindergartensList.data?.pagination?.total_count || 0;
  const loading = kindergartensList.loading;

  const screens = useBreakpoint();
  const [searchParams, setSearchParams] = useSearchParams();
  // const [kindergartens, setKindergartens] = useState<any[]>([]);
  // const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const segmentedParams: any = searchParams.get('type');
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  // const [totalCount, setTotalCount] = useState(0);

  const handleChangeSegmented = (value: any) => {
    setSearchParams({ type: value });
  };

  const handlePaginationChange = (newPage: number, newPageSize?: number) => {
  setPage(newPage);
  if (newPageSize && newPageSize !== pageSize) {
    setPageSize(newPageSize);
  }
};


  useEffect(() => {
    dispatch(fetchKindergartensListAction({ page, per_page: pageSize, search: searchTerm }));
  }, [page, pageSize]);

  const handleKindergartenSearch = () => {
    dispatch(fetchKindergartensListAction({ search: searchTerm }));
  };

  const dataSource = kindergartens.map((item, index) => ({
    key: item.id,
    number: item.id,
    name: item.name,
    address: item.address,
    director: item.director_fio,
    phones: item.phone,
    consultationPoint: (
      <Link to={`/articles?type=speech_therapist/${item.id}`}>
        <MyText color='rgba(0, 141, 210, 1)'>
          {item.consultation ? `${t("enroll")}` : `${t("noConsultations")}`} 
        </MyText>
      </Link>
    ),
  }));

  const columns = [
    {
      title: <span style={{ lineHeight: '32px', fontSize: '16px', fontWeight: 600 }}>№</span>,
      dataIndex: 'number',
      key: 'number',
      width: '5%',
    },
    {
      title: <span style={{ lineHeight: '32px', fontSize: '16px', fontWeight: 600 }}>{`${t("name")}`}</span>,
      dataIndex: 'name',
      key: 'name',
      width: '18%',
    },
    {
      title: <span style={{ lineHeight: '32px', fontSize: '16px', fontWeight: 600 }}>{`${t("address")}`}</span>,
      dataIndex: 'address',
      key: 'address',
      width: '20%',
    },
    {
      title: <span style={{ lineHeight: '32px', fontSize: '16px', fontWeight: 600 }}>{`${t("managerFullName")}`}</span>,
      dataIndex: 'director',
      key: 'director',
      width: '15%',
    },
    {
      title: <span style={{ lineHeight: '32px', fontSize: '16px', fontWeight: 600 }}>{`${t("phones")}`}</span>,
      dataIndex: 'phones',
      key: 'phones',
      width: '15%',
    },
    {
      title: <span style={{ lineHeight: '32px', fontSize: '16px', fontWeight: 600 }}>{`${t("consultationPoint")}`}</span>,
      dataIndex: 'consultationPoint',
      key: 'consultationPoint',
      width: '15%',
    },
  ];

  return (
    <Row justify='center'>
      <Col span={20}>
        <Row gutter={[32, 32]}>
          <Col span={24}>
            <MyText color='#0A033C' size={32} weight={800}
                    style={{ fontFamily: 'Nunito', display: 'block', textAlign: 'center' }}>
              {`${t("kindergartensList")}`}
            </MyText>
          </Col>

          <Col span={24}>
            <StyledCard>
            <SearchContainer>
            {!isMobile && (
              <SearchIcon>
                <SearchOutlined />
              </SearchIcon>
            )}
              <SearchInput
                type="text"
                placeholder={isMobile ? `${t("search")}...` : `${t("searchByKeyword")}...`}
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                onKeyDown={(e) => {
                          if (e.key === "Enter") {
                          handleKindergartenSearch()
                          }
                        }}
              />
              <SearchButton isMobile={isMobile} onClick={handleKindergartenSearch}>
              {isMobile ? <SearchOutlined style={{ fontSize: '30px' }} /> : `${t("search")}`}
            </SearchButton>
            </SearchContainer>

            {!screens.xs && (
              <Table dataSource={dataSource} columns={columns} pagination={false} loading={loading} />
            )}
              </StyledCard>
              {screens.xs && (
            kindergartens.map((item, index) => (

              <StyledCard key={item.id} style={{ marginTop: 12 }}>
              <Col style={{marginTop: 16}}>
                <MyText size={16} weight={800} style={{fontFamily: 'Nunito'}}>№ {index + 1}</MyText>
              </Col>
              <Col>
                <MyText size={14} weight={600} style={{fontFamily: 'Nunito'}}>{`${t("name")}`}: {item.name}</MyText>
              </Col>
              <Col>
                <MyText size={14} weight={600} style={{fontFamily: 'Nunito'}}>{`${t("address")}`}: {item.address}</MyText>
              </Col>
              <Col>
                <MyText size={14} weight={600} style={{fontFamily: 'Nunito'}}>{`${t("managerFullName")}`}: {item.director_fio}</MyText>
              </Col>
              <Col>
                <MyText size={14} weight={600} style={{fontFamily: 'Nunito'}}>{`${t("phones")}`}: {item.phone}</MyText>
              </Col>
              <Divider style={{marginTop: 16, marginBottom: 12}}/>
              <Col span={24} style={{marginTop: 12, marginBottom: 12}}>
              <Link to={`/articles?type=speech_therapist/${item.id}`}>
                <MyText color='rgba(0, 141, 210, 1)'>
                  {item.consultation ? `${t("enroll")}` : `${t("noConsultations")}`} 
                </MyText>
              </Link>
              </Col>
            </StyledCard>
             ))
          )}
          {kindergartens.length > 6 && (
                  <div style={{ display: 'flex', justifyContent: 'center', marginTop: '32px' }}>
                    <Pagination
                      current={page}
                      pageSize={pageSize}
                      onChange={handlePaginationChange}
                      onShowSizeChange={handlePaginationChange}
                      total={totalCount}
                      showSizeChanger
                    />
                  </div>
                )}
          </Col>
        </Row>
      </Col>
    </Row>
  );
};
